import React from "react"
import { Id, OperationsContainer, OrderLineInfo, Reason } from "./Shared.styled"
import { OrderCompensation } from "lib/types/generated/graphql-types"
import Money from "../../../Money"
import DineroFactory from "dinero.js"
import { useOrderTabContext } from "../../../../views/Orders/OrderViews/OrderTabContext"

type Props = {
  compensation: OrderCompensation
  orderLineId: string
  currencyCode: string
  salePriceAmount: number
}

const Compensations = ({ compensation, orderLineId, currencyCode, salePriceAmount }: Props) => {
  const { switchToUpdatesTab } = useOrderTabContext()

  const compensatedOrderLine = compensation?.orderLines?.find(
    (ol) => ol.orderLineId === orderLineId
  )

  const getPercentage = (discountAmount: number, salePriceAmount: number) => {
    return ((discountAmount / salePriceAmount) * 100).toFixed(0)
  }

  return (
    <OperationsContainer>
      <div>
        <b>Compensation</b>
      <div>
        {compensation?.reason && (<Reason>{compensation?.reason?.code} - {compensation?.reason?.cause}</Reason>)}
      </div>{" "}
      <Id onClick={switchToUpdatesTab}>{compensation.id}</Id>
      </div>
      <div>
        {" "}
        <OrderLineInfo>
          <div>Compensated amount</div>
          <div>
            -
            <Money
              amount={compensatedOrderLine?.totalDiscountAmount ?? 0}
              currencyUnit={currencyCode as DineroFactory.Currency}
            />
          </div>
        </OrderLineInfo>
        <OrderLineInfo>
          <div>Compensated percentage</div>
          <div>
            {getPercentage(compensatedOrderLine?.totalDiscountAmount ?? 0, salePriceAmount)}%
          </div>
        </OrderLineInfo>
      </div>
    </OperationsContainer>
  )
}

export default Compensations
